import request from '@/utils/request'
export function login(data) {
  // 返回一个axios对象 => promise // 返回了一个promise对象
  return request({
    url: '/authorizations/',
    method: 'post',
    data
  })
}

// ── 自助注册 / 忘记密码（2026-10-21）──
// 说明：后端 users/urls.py 里这几条路径写成了 'api/sms_code/' 这种（本项目既有约定），
// 而 request.js 的 baseURL 已经是 /api，所以这里再带一层 'api/' 前缀，实际打到
//   https://hr.xinbiancheng.cn/api/api/sms_code/
// 和后端 users/urls.py 完全对齐（change_password 也是这么调的，别改这里单边）
export function sendSmsCode(data) {
  return request({ url: 'api/sms_code/', method: 'post', data })
}

export function registerUser(data) {
  return request({ url: 'api/register/', method: 'post', data })
}

export function forgotPassword(data) {
  return request({ url: 'api/forgot_password/', method: 'post', data })
}

export function getInfo(token) {}
export function logout() {

}
